/**
 * RFC 9457 hata kodları → kullanıcı iletisi (08 §9.3; kodlar documents/moduller/README.md "Hata kodları").
 * Modüle özgü kodlar `modül.kaynak.hata` yoluyla iç içe yazılır: `errors.workforce.department.in_use`.
 * Katalogda karşılığı olmayan kodda sunucunun `detail` iletisi gösterilir. `{retryAfterSeconds}` ve
 * `{remainingAttempts}` problem gövdesinin aynı adlı alanlarından gelir (`problemMessage`).
 */
export const errors = {
  validation: 'Bazı alanlar hatalı. İşaretli alanları düzeltip tekrar deneyin.',
  unauthorized: 'Oturumunuzun süresi doldu. Devam etmek için yeniden oturum açın.',
  forbidden: 'Bu işlem için yetkiniz yok. Gerekiyorsa Şirket yöneticinizden isteyin.',
  not_found: 'Aradığınız kayıt bulunamadı. Silinmiş ya da taşınmış olabilir.',
  method_not_allowed: 'Bu işlem bu kayıtta yapılamıyor.',
  conflict: 'Bu işlem mevcut kayıtlarla çakışıyor.',
  concurrency_conflict: 'Kayıt siz düzenlerken başka biri tarafından değiştirildi. Yenileyip tekrar deneyin.',
  gone: 'Bu bağlantı ya da kayıt artık geçerli değil.',
  precondition_failed: 'Kayıt siz açtıktan sonra değişti. Güncel hâlini görmek için yenileyin.',
  payload_too_large: 'Gönderilen içerik izin verilen boyutu aşıyor. Daha küçük bir içerikle tekrar deneyin.',
  unsupported_media_type: 'Gönderilen içerik türü desteklenmiyor.',
  unprocessable: 'Bu işlem şu an desteklenmiyor.',
  rate_limited: 'Çok fazla istek gönderildi. Biraz bekleyip tekrar deneyin.',
  internal: 'Bir şeyler ters gitti. Tekrar deneyin. Sorun sürerse destek koduyla bize yazın: {supportCode}.',
  failure: 'Bir şeyler ters gitti. Tekrar deneyin. Sorun sürerse destek koduyla bize yazın: {supportCode}.',
  network: 'Bağlantı yok. İnternet bağlantınızı kontrol edip tekrar deneyin.',
  tenant_suspended: 'Şirket hesabı askıya alındı. Askı sürerken yalnız İşletme sahibi oturum açar; okuma, ödeme ve dışa aktarma dışındaki işlemler kapalıdır.',
  // S44 değerlendirmesi: herkese gösterilir; tahsilat takibinde plan seçimi salt okunuru kaldırmaz. Neden ve çözüm hesap durumu bandındadır.
  tenant_read_only: 'Şirket hesabı salt okunur; değişiklik yapılamıyor. Mesai kaydı ve dışa aktarma açık. Nedeni ve çözümü sayfanın üstündeki banttadır.',
  tenant_closed: 'Şirket hesabı kapatıldı. Verilerinizin iade paketini İşletme sahibi indirebilir.',
  membership_inactive: 'Bu şirketteki erişiminiz kapatıldı. Şirket yöneticinize başvurun.',
  permission_denied: 'Bu işlem için yetkiniz yok. Gerekiyorsa Şirket yöneticinizden isteyin.',
  // S41 (S41-K5): kapalı özellik planda ya da modül ayarında kapalıdır; veri silinmez. Ekran "Yükselt" kartını ayrıca gösterir.
  feature_disabled: 'Bu özellik şirketinizin planında ya da modül ayarlarında kapalı. Verileriniz silinmez; açmak için Şirket yöneticinize başvurun.',
  // S41: planın sert sınırı (ör. Ücretsiz planda 6. aktif çalışan, depolama dolu); sayı ve anahtar sunucunun `detail`'indedir.
  plan_limit_reached: 'Planınızın sınırına ulaşıldı. Devam etmek için planınızı yükseltin; mevcut verileriniz silinmez.',
  step_up_required: 'Bu işlem için kimliğinizi yeniden doğrulamanız gerekiyor.',
  // S44: destek oturumu (ADR-002 §2.4) salt okumadır; bittiğinde (süre, iptal, kapatma) panel bitiş ekranını gösterir.
  support_session_read_only: 'Destek oturumu salt okumadır; bu işlem destek oturumunda yapılamaz.',
  support_session_ended: 'Destek oturumu sona erdi. Yeni oturum için backoffice\'ten yeniden başlatın.',
  support_access: {
    grant_active: 'Geçerli bir destek erişimi izni var. Süreyi değiştirmek için önce izni iptal edin.',
    grant_not_found: 'Destek erişimi izni bulunamadı.',
    grant_not_active: 'Bu izin zaten iptal edildi ya da süresi doldu.',
    grant_required: 'İşletmenin geçerli bir destek erişimi izni yok. İşletme sahibi ya da Şirket yöneticisi panelden izin vermeli.',
    tenant_not_found: 'İşletme bulunamadı.',
    tenant_unavailable: 'Askıdaki ya da kapalı işletmede destek oturumu açılamaz.',
    session_open: 'Açık bir destek oturumunuz var. Panele geçin ya da oturumu bitirin.',
    session_not_found: 'Destek oturumu bulunamadı.',
    session_closed: 'Destek oturumu kapalı.',
    not_own_session: 'Panele yalnız oturumu açan operatör geçebilir.',
    handoff_invalid: 'Destek oturumu bağlantısı geçersiz ya da süresi doldu. Backoffice\'ten yeniden panele geçin.',
    not_in_session: 'Açık bir destek oturumu yok.',
  },
  files: {
    upload: {
      expired: 'Yükleme süresi doldu. Dosyayı yeniden seçin.',
      used: 'Bu yükleme zaten tamamlandı. Dosyayı yeniden seçin.',
      not_found: 'Yükleme bulunamadı. Dosyayı yeniden seçin.',
      purpose_unknown: 'Bu dosya burada kullanılamıyor.',
      too_large: 'Dosya izin verilen boyutu aşıyor. Daha küçük bir dosya seçin.',
      type_not_allowed: 'Bu dosya türü desteklenmiyor. İzin verilen türlerden birini seçin.',
      signature_mismatch: 'Dosyanın içeriği uzantısıyla uyuşmuyor. Dosyayı kontrol edip yeniden seçin.',
      size_mismatch: 'Dosya eksik yüklendi. Yeniden deneyin.',
      hash_mismatch: 'Dosya yüklenirken bozuldu. Yeniden deneyin.',
      infected: 'Dosyada zararlı içerik bulundu; yüklenmedi.',
    },
    file: {
      not_found: 'Dosya bulunamadı. Silinmiş olabilir.',
      expired: 'Dosyanın saklama süresi doldu; artık indirilemez.',
    },
    link: {
      expired: 'İndirme bağlantısının süresi doldu. Sayfayı yenileyip yeniden indirin.',
      invalid: 'İndirme bağlantısı geçersiz. Sayfayı yenileyip yeniden indirin.',
    },
  },
  privacy: {
    notice: {
      not_found: 'Aydınlatma metni bulunamadı.',
      draft_exists: 'Bu tür için zaten bir taslak var. Önce onu düzenleyin ya da yayınlayın.',
      published: 'Yayınlanmış metin değiştirilemez. Yeni sürüm için taslak oluşturun.',
      not_published: 'Bu metin henüz yayınlanmadı.',
      outdated: 'Metnin daha yeni bir sürümü yayınlandı. Güncel metni okuyun.',
    },
  },
  access: {
    company_scope_required: 'Bu işlem tüm şirket kapsamında yetki gerektirir.',
    out_of_scope: 'Seçtiğiniz değer yetki kapsamınızın dışında.',
    owner_transfer_only: 'İşletme sahibi rolü yalnız sahiplik devriyle verilir.',
    assignment_exceeds_actor: 'Kendi yetkilerinizin dışında bir rol veremezsiniz.',
    scope_exceeds_actor: 'Kendi kapsamınızın dışında bir kapsamla rol veremezsiniz.',
    target_exceeds_actor: 'Yetkisi sizinkini aşan bir kişinin rolünü ya da erişimini değiştiremezsiniz.',
    last_owner: 'Şirketin tek İşletme sahibi bu kişi. Önce sahipliği devredin.',
    last_assignment: 'Kişinin en az bir rolü olmalı. Erişimini kapatmak için çalışan detayındaki "Erişimi kapat"ı kullanın.',
    assignment_exists: 'Bu rol bu kapsamla zaten atanmış.',
    template_unknown: 'Seçilen rol şablonu geçerli değil.',
    scope_invalid: 'Seçilen kapsam geçerli değil.',
    membership_not_found: 'Üyelik bulunamadı.',
    assignment_not_found: 'Rol ataması bulunamadı. Kaldırılmış olabilir.',
    // S44: özel roller.
    custom_role_not_found: 'Özel rol bulunamadı. Silinmiş ya da başka bir şirkete ait olabilir.',
    custom_role_archived: 'Bu özel rol arşivde. Önce arşivden geri alın.',
    custom_role_name_taken: 'Bu adla bir özel rol zaten var. Başka bir ad seçin.',
    custom_role_in_use: 'Bu rol kişilere verilmiş. Arşivlemeden önce rolü kişilerin Erişim sekmesinden kaldırın.',
    custom_role_source_invalid: 'Bu şablon kopyalanamaz. İşletme sahibi ve Çalışan özel role kaynak olamaz.',
    custom_role_exceeds_actor: 'Kendi yetkilerinizde olmayan bir yetkiyi role ekleyemezsiniz.',
    permission_not_customizable: 'Bu yetki özel role konamaz: yalnız İşletme sahibinde ya da yalnız İK şablonunda bulunur.',
    permission_unknown: 'Seçilen yetkilerden biri artık katalogda yok. Sayfayı yenileyip tekrar deneyin.',
    ownership: {
      not_owner: 'Sahipliği yalnız İşletme sahibi devredebilir.',
      target_invalid: 'Sahiplik, şirketin erişimi açık başka bir kişisine devredilebilir.',
      already_owner: 'Bu kişi zaten İşletme sahibi.',
      transfer_open: 'Tamamlanmamış bir sahiplik devri var. Önce onu tamamlayın ya da iptal edin.',
      not_found: 'Sahiplik devri bulunamadı.',
      not_awaiting: 'Sahiplik devri bu adımda değil, iptal edilmiş ya da süresi dolmuş.',
    },
  },
  identity: {
    login: {
      invalid_credentials:
        'Oturum açılamadı. Bilgilerinizi kontrol edin; çok sayıda hatalı denemeden sonra birkaç dakika beklemeniz gerekir.',
      challenge_invalid: 'Oturum açma adımının süresi doldu. Baştan oturum açın.',
      too_many_attempts: 'Bu hesap için çok sayıda deneme yapıldı. Biraz bekleyip tekrar deneyin.',
    },
    // SK-29: kod ya da bağlantı gönderen anonim isteklerin güvenlik doğrulaması (oturum açma kodu, şifre yenileme, aktivasyon kodu).
    captcha_required: 'Devam etmek için güvenlik doğrulamasını tamamlayın.',
    captcha_failed: 'Güvenlik doğrulaması geçmedi. Yeniden deneyin.',
    membership: {
      not_found: 'Bu şirkette etkin bir üyeliğiniz yok.',
      exists: 'Bu hesap bu şirkette zaten üye. Oturum açmayı deneyin.',
      other_employee: 'Bu kişi şirkette başka bir çalışan kaydıyla zaten üye.',
    },
    contact: {
      missing: 'Hesabınızda doğrulanmış telefon ya da e-posta yok. Şirket yöneticinize başvurun.',
    },
    otp: {
      invalid: 'Kod hatalı. {remainingAttempts} deneme hakkınız kaldı.',
      unknown: 'Kod geçersiz. Yeni kod isteyin.',
      expired: 'Kodun süresi doldu. Yeni kod isteyin.',
      attempts_exceeded: 'Çok sayıda hatalı deneme yapıldı. Yeni kod isteyin.',
      country_not_allowed: 'Bu ülke koduna doğrulama kodu gönderilemiyor. Türkiye cep telefonu numarası yazın.',
      resend_too_soon: 'Yeni kod için {retryAfterSeconds} saniye bekleyin.',
      limit_exceeded: 'Bu numaraya ya da adrese çok sayıda kod gönderildi. Biraz bekleyip tekrar deneyin.',
      daily_limit: 'Günlük doğrulama kodu sınırına ulaşıldı. Daha sonra tekrar deneyin.',
      // S41 (PK-04): şirketin aylık SMS doğrulama kodu tavanı doldu ve kişinin e-postası yok.
      sms_quota_exhausted: 'Şirketin bu ayki SMS doğrulama kodu hakkı doldu. E-posta adresinizle devam edin ya da Şirket yöneticinize başvurun.',
      // S62-c (SK-19) ve SK-29: SMS kapalı ya da şirket SMS'li planda değil; telefona kod gönderilmez (oturum açma, telefon değişikliği,
      // e-postası olmayan hesabın kodu). İki neden aynı kodla gelir; ileti ikisine de uyar.
      sms_unavailable: 'SMS ile kod gönderilemiyor; e-posta adresinizle devam edin.',
    },
    pin: {
      device_unknown: 'Bu cihazda PIN ile oturum açılamıyor. Doğrulama koduyla oturum açın.',
      not_set: 'Hesabınızda PIN yok. Doğrulama koduyla oturum açıp PIN belirleyin.',
      locked: 'PIN çok sayıda hatalı deneme nedeniyle kilitlendi. Doğrulama koduyla oturum açıp yeni PIN belirleyin.',
      invalid: 'PIN hatalı. {remainingAttempts} deneme hakkınız kaldı.',
    },
    mfa: {
      invalid_code: 'Doğrulama kodu hatalı. Doğrulayıcı uygulamadaki güncel kodu ya da bir kurtarma kodunu yazın.',
      enrollment_invalid_code: 'Kod doğrulanamadı. Doğrulayıcı uygulamadaki güncel kodu yazın.',
      locked: 'Çok sayıda hatalı deneme yapıldı. Biraz bekleyip tekrar deneyin.',
      already_enabled: 'İki adımlı doğrulama zaten açık.',
      not_started: 'Önce iki adımlı doğrulama kaydını başlatın.',
      not_enabled: 'İki adımlı doğrulama açık değil.',
      required_for_platform: 'Platform hesabınız olduğu için iki adımlı doğrulama kapatılamaz.',
    },
    step_up: {
      invalid: 'Doğrulama başarısız. Bilgilerinizi kontrol edip tekrar deneyin.',
      method_not_allowed:
        'Bu yöntemle yeniden doğrulama yapılamıyor. İki adımlı doğrulama açıksa doğrulayıcı uygulamadaki kodu kullanın.',
    },
    session: {
      refresh_invalid: 'Oturumunuzun süresi doldu. Devam etmek için yeniden oturum açın.',
      request_rejected: 'İstek güvenlik denetiminden geçmedi. Sayfayı yenileyip tekrar deneyin.',
    },
    reset: {
      invalid: 'Bağlantı geçersiz. Yeni bir şifre sıfırlama bağlantısı isteyin.',
      used: 'Bu bağlantı zaten kullanılmış. Yeni bir şifre sıfırlama bağlantısı isteyin.',
      expired: 'Bağlantının süresi dolmuş. Yeni bir şifre sıfırlama bağlantısı isteyin.',
    },
    role: {
      invalid: 'Seçilen rol bu işlem için geçerli değil.',
    },
    // S27: hesabı olan çalışan kioskta kendi hesabının PIN'ini kullanır.
    kiosk: {
      account_pin: 'Bu çalışanın hesabı var; kioskta kendi PIN\'ini kullanır. PIN\'ini unuttuysa telefonuna gelen kodla yenileyebilir.',
    },
    device: {
      not_found: 'Cihaz bulunamadı ya da oturumu zaten kapatılmış.',
      current_unknown: 'Bu tarayıcı tanınmadı. Diğer cihazları kapatmak için bu tarayıcıda yeniden oturum açın.',
    },
    // S25: passkey ve çalışanın yeni telefonu için yönetici kararı.
    passkey: {
      invalid: 'Passkey doğrulanamadı. Tekrar deneyin ya da başka bir yöntem kullanın.',
      not_found: 'Passkey bulunamadı ya da zaten kaldırılmış.',
    },
    device_trust: {
      not_pending: 'Bu cihaz artık onay beklemiyor. Listeyi yenileyin.',
      self_decision: 'Kendi cihazınız için karar veremezsiniz; başka bir yöneticiye başvurun.',
    },
    // S44 değerlendirmesi: Google ve Microsoft dönüşü hem oturum açmada hem kayıtta ("Google ile devam et") görünür; iletiler ikisine de
    // uyar. Hesabı olmayan kişi çalışansa davet ister, işletmesini kaydedecekse kayda gider (yanlışlıkla yeni şirket açılmasın).
    oidc: {
      state_invalid: 'İsteğin süresi doldu ya da başka bir tarayıcıda başlatıldı. Yeniden deneyin.',
      cancelled: 'Google ya da Microsoft sayfasında vazgeçildi. İsterseniz yeniden deneyin.',
      failed: 'Google ya da Microsoft hesabınız doğrulanamadı. Yeniden deneyin.',
      email_unverified: 'Bu hesabın e-posta adresi Google ya da Microsoft\'ta doğrulanmamış. Doğrulanmış bir e-posta adresiyle deneyin.',
      no_account:
        'Bu e-posta adresiyle açılmış bir TicariShift hesabı yok. Bir şirkette çalışıyorsanız yöneticinizden davet isteyin; işletmenizi kaydedecekseniz kayıt sayfasından başlayın.',
    },
    // S44 değerlendirmesi: zorunluluk yalnız şifreyi kapatır; kodla, PIN ve passkey ile oturum açma sürer (identity.md "Kurumsal SSO").
    sso: {
      required: 'Şirketiniz şifreyle oturum açmayı kapattı. Google ya da Microsoft ile ya da kodla oturum açın.',
    },
  },
  approvals: {
    request: {
      not_found: 'Talep bulunamadı. Geri çekilmiş olabilir.',
      already_pending: 'Bu kayıt için karar bekleyen bir talep zaten var.',
      no_approver: 'Bu talebi onaylayabilecek uygun bir yönetici yok. Onay akışını ya da rolleri gözden geçirin.',
      subject_not_found: 'Talebin ilgili olduğu çalışan bulunamadı.',
      not_pending: 'Bu talep artık karar beklemiyor. Listeyi yenileyin.',
      not_requester: 'Talebi yalnız açan kişi geri çekebilir.',
    },
    decision: {
      maker_checker: 'Kendi talebinize ya da sizin açtığınız bir talebe karar veremezsiniz.',
      not_assignee: 'Bu talep sizin kararınızı beklemiyor.',
      not_eligible: 'Bu talebe karar verme yetkiniz artık yok; talep yedek onaylayıcıya geçecek.',
    },
    delegation: {
      not_found: 'Vekâlet bulunamadı. Kaldırılmış olabilir.',
      others_forbidden: 'Başkası adına vekâlet tanımlamak için onay ayarlarını yönetme yetkisi gerekir.',
      overlaps: 'Bu tarihlerde bu kişinin başka bir vekâleti var. Önce onu kaldırın ya da tarihleri değiştirin.',
    },
    policy: {
      not_found: 'Onay politikası bulunamadı.',
      self_approval_owner_only: 'Öz-onayı yalnız İşletme sahibi açıp kapatabilir.',
      default_required: 'Talep türünün varsayılan akışı kapatılamaz; koşullu akışları kapatabilirsiniz.',
    },
  },
  idempotency: {
    key_reused: 'Bu işlem farklı bir istekle karıştı. Sayfayı yenileyip yeniden deneyin.',
  },
  attendance: {
    employee: {
      inactive: 'Hesabınıza bağlı etkin bir çalışan kaydı yok. İK ile görüşün.',
    },
    event: {
      not_found: 'Devam kaydı bulunamadı.',
    },
    session: {
      not_found: 'Mesai kaydı bulunamadı.',
      already_closed: 'Bu mesai zaten bitmiş; eksik bitiş bildirmeniz gerekmez.',
    },
    correction: {
      target_invalid: 'Düzeltme kaydına düzeltme açılamaz.',
      pending_exists: 'Bu kayıt için karar bekleyen bir düzeltme zaten var.',
      no_session: 'Bu gün için mesai kaydı yok; eksik kayıt yalnız başlamış bir mesaiye eklenebilir.',
    },
  },
  // S24'ten beri tarama niyeti ve punch retlerinin `code` alanı sebep kodudur (`code_invalid`, `intent_expired`…); metinleri
  // Okut'un ekranlarındadır (`apps/panel/src/features/scan/copy.ts`). Eski `verification.code.*` kodları kalktı. S25: QR
  // Ekranı bağlama ve yönetimi (panel); ekranın kendi uçlarının kodları (`device_unpaired`, `pairing_*`) QR Ekranı
  // girişinin metinlerindedir (`apps/panel/src/display/copy.ts`). Ekran jetonu kodları (`verification.display.*`) kalktı.
  verification: {
    pairing_code_invalid: 'Kod tanınmadı ya da süresi doldu. Ekrandaki 6 haneli kodu kontrol edin.',
    pairing_locked: 'Çok sayıda hatalı kod girildi. Biraz bekleyip tekrar deneyin.',
    entry_point_not_found: 'Okutma noktası bulunamadı. Listeyi yenileyip tekrar deneyin.',
    location_inactive: 'Lokasyon etkin değil. Ekranı etkin bir lokasyona bağlayın.',
    device_not_found: 'QR Ekranı bulunamadı. Listeyi yenileyip tekrar deneyin.',
    device_revoked: 'Bu QR Ekranının bağlantısı zaten kaldırılmış.',
    device_admin_pin_invalid: 'Yönetici PIN\'i hatalı. {remainingAttempts} deneme hakkınız kaldı.',
    device_admin_pin_locked: 'Yönetici PIN\'i çok sayıda hatalı deneme nedeniyle 15 dakika kilitlendi.',
    device_admin_pin_not_set: 'Bu ekran için yönetici PIN\'i belirlenmemiş. QR Ekranları sayfasından belirleyin.',
    // S26: okutma noktası, güvenlik şablonu ve denemeler (CHK-45: geçersiz birleşim kaydedilmez).
    location_not_found: 'Lokasyon bulunamadı. Arşivlenmiş ya da yetki kapsamınızın dışında olabilir.',
    method_unavailable: 'Bu okutma yöntemi henüz kurulamıyor. Ekran QR seçin.',
    template_method_mismatch: 'Bu güvenlik şablonu seçilen okutma yöntemiyle kullanılamaz.',
    location_coordinates_required:
      'Bu güvenlik şablonu konum ister. Önce lokasyonun haritadaki yerini ve konum sınırını kaydedin.',
    attempt_not_found: 'Okutma denemesi bulunamadı. Silinmiş ya da yetki kapsamınızın dışında olabilir.',
    // S27: kiosk bağlama, kişisel QR ve kioskun kendi uçları.
    device_kind_mismatch:
      'Kiosk yalnız Kiosk yöntemli, QR Ekranı yalnız Ekran QR yöntemli okutma noktasına bağlanır. Uygun okutma noktasını seçin.',
    device_not_kiosk: 'Bu cihaz kiosk olarak bağlanmamış. Kiosk için tablette /kiosk adresini açıp yeniden bağlayın.',
    kiosk_identification_not_found: 'Tespit bulunamadı. Kartınızı ya da QR\'ınızı yeniden okutun.',
    entry_point_devices_bound:
      'Bu okutma noktasına bağlı cihaz var; yöntemi değiştirmek için önce cihazın bağlantısını kaldırın ya da yeni bir okutma noktası açın.',
    personal_qr_device_required: 'Kişisel QR yalnız uygulamada oturum açtığınız telefonda kullanılabilir. Telefonunuzdan oturum açın.',
    personal_qr_device_pending: 'Bu telefon henüz onaylanmadı. Yöneticiniz telefonu onaylayınca kişisel QR\'ınız hazır olur.',
    personal_qr_device_rejected: 'Bu telefon mesai kaydı için onaylanmadı. Yöneticinize başvurun.',
    // S28: saha profili ve poster/NFC etiketi.
    employee_not_found: 'Çalışan bulunamadı ya da yetki kapsamınızın dışında.',
    field_profile_not_found: 'Çalışanın saha profili yok. Sayfayı yenileyip tekrar deneyin.',
    field_point_invalid: 'Seçilen saha noktalarından biri artık yok ya da Saha yöntemli değil. Listeyi yenileyip yeniden seçin.',
    poster_unavailable: 'Bu okutma noktası poster ya da NFC etiketi kullanmıyor.',
    poster_token_missing: 'Posterin kodu okunamıyor. Poster kodunu yenileyip posteri yeniden yazdırın.',
  },
  // S27: Canlı Durum ve yoklama listesi.
  reporting: {
    location_not_found: 'Lokasyon bulunamadı. Arşivlenmiş ya da yetki kapsamınızın dışında olabilir.',
    employee_not_found: 'Çalışan bulunamadı ya da yetki kapsamınızın dışında.',
  },
  notifications: {
    not_found: 'Bildirim bulunamadı. Silinmiş olabilir.',
    preference: {
      unknown_event: 'Bu bildirim türü artık yok. Sayfayı yenileyip tekrar deneyin.',
      unsupported_channel: 'Bu bildirim seçtiğiniz kanaldan gönderilmiyor.',
      mandatory: 'Bu bildirim hesabınızın güvenliği için zorunludur; kapatılamaz.',
      in_app_locked: 'Uygulama içi bildirimler kapatılamaz; e-posta, SMS ve anlık bildirim gibi kanalları kapatabilirsiniz.',
    },
    push: {
      disabled: 'Anlık bildirimler şu an kullanılamıyor.',
    },
    push_subscription: {
      not_found: 'Bu cihazın anlık bildirim kaydı bulunamadı. Zaten kapatılmış olabilir.',
    },
  },
  scheduling: {
    shift_template: {
      not_found: 'Vardiya şablonu bulunamadı. Arşivlenmiş ya da silinmiş olabilir.',
      code_taken: 'Bu kodla bir vardiya şablonu zaten var. Başka bir kod seçin.',
      in_use: 'Şablon bir rotasyon deseninde kullanılıyor. Arşivlemeden önce deseni değiştirin.',
      archived: 'Arşivlenmiş vardiya şablonu kullanılamaz. Etkin bir şablon seçin.',
    },
    // S35: personel ihtiyacı ve eksik hücreden açık vardiya (S35-K4).
    staffing_requirement: {
      not_found: 'Personel ihtiyacı kaydı bulunamadı ya da planlama yetkinizin dışında. Sayfayı yenileyin.',
      not_applicable: 'Bu personel ihtiyacı kaydı seçilen günde geçerli değil. Planı yenileyip yeniden deneyin.',
      no_shortage: 'Bu gün için eksik yok: ihtiyaç atanan vardiyalarla ve açık vardiyalarla karşılanıyor.',
    },
    rotation_pattern: {
      not_found: 'Rotasyon deseni bulunamadı.',
    },
    preset: {
      not_found: 'Hazır desen bulunamadı.',
      template_conflict:
        'Aynı kodlu şablonunuz hazır desendekinden farklı saatlerde. Şablonun kodunu değiştirin ya da şablonu arşivleyin.',
    },
    crew: {
      not_found: 'Ekip bulunamadı.',
      code_taken: 'Bu kodla bir ekip zaten var. Başka bir kod seçin.',
      member_overlap: 'Çalışan bu tarihlerde başka bir ekipte. Bir çalışan aynı tarihte yalnız bir ekipte olabilir.',
      member_not_found: 'Çalışan bu ekibin üyesi değil.',
    },
    pattern_assignment: {
      not_found: 'Çalışma düzeni ataması bulunamadı.',
      overlap: 'Bu hedefin aynı tarihlerde başka bir çalışma düzeni var. Öncekine bitiş tarihi verin ya da başlangıcı değiştirin.',
    },
    employee: {
      not_found: 'Çalışan bulunamadı ya da planlama yetkinizin dışında.',
    },
    department: {
      not_found: 'Departman bulunamadı ya da planlama yetkinizin dışında.',
    },
    location: {
      not_found: 'Lokasyon bulunamadı ya da planlama yetkinizin dışında.',
    },
    holiday: {
      not_found: 'Tatil günü bulunamadı.',
      system_day: 'Resmî tatil günleri kaldırılamaz; yalnız şirket günlerini kaldırabilirsiniz.',
      exists: 'Bu gün zaten şirket tatili.',
    },
    assignment: {
      past: 'Geçmiş ya da başlamış bir gün değiştirilemez.',
      conflict: 'Vardiya, çalışanın başka bir vardiyasıyla çakışıyor.',
      timezone_unresolved: 'Çalışanın saat dilimi belirlenemedi. Lokasyonun, şubenin ve şirketin saat dilimini kontrol edin.',
      not_found: 'Vardiya bulunamadı. Plan değişmiş olabilir; ekranı yenileyin.',
    },
    quick_setup: {
      night_post_limit:
        'Gece postası 7,5 saati aşıyor. Bu düzen yalnız turizm, özel güvenlik, sağlık ve petrol sektörlerinde kurulabilir; saatleri kısaltın.',
      plan_exists:
        'Seçtiğiniz çalışanların bu tarihten sonra geçerli bir çalışma düzeni var. Değiştirmek için mevcut düzenin bitirilmesini onaylayın.',
    },
    calendar: {
      employee_required: 'Takvim aboneliği için etkin bir çalışan kaydınız olmalı. İK ile görüşün.',
      not_found: 'Takvim adresi bulunamadı ya da yenilenmiş. Vardiyam ekranından yeni adres alın.',
    },
    plan: {
      blocked: 'Planda gerekçesiz aşılamayan kural ihlali (ENGEL) var. İhlalleri düzeltin ya da yetkiniz varsa gerekçe girin.',
      override_forbidden: 'Kural ihlalini gerekçeyle aşmak için bu çalışanın çizelgesini yayınlama yetkiniz olmalı.',
    },
    roster: {
      not_found: 'Çizelge yayını bulunamadı.',
    },
    week_template: {
      not_found: 'Şablon hafta bulunamadı.',
    },
    holiday_calendar: {
      not_found: 'Tatil takvimi bulunamadı.',
    },
    holiday_version: {
      not_found: 'Tatil takvimi sürümü bulunamadı.',
      not_draft: 'Yayınlanmış sürüm değiştirilemez. Yeni bir taslak açın.',
      draft_exists: 'Bu yıl için açık bir taslak zaten var. Önce onu düzenleyin ya da yayınlayın.',
    },
    // S34: vardiya değişimi, açık vardiya, müsaitlik ve FM ön onayının plan tarafı (scheduling.md "Vardiya değişimi, açık vardiya ve müsaitlik").
    swap: {
      disabled: 'Vardiya değişimi şirketinizde kapalı.',
      not_found: 'Vardiya değişimi talebi bulunamadı.',
      not_pending: 'Talep bu adımda değil ya da sonuçlandı. Listeyi yenileyin.',
      not_party: 'Bu işlemi yalnız talebin ilgili tarafı yapabilir.',
      pending_exists: 'Bu vardiya için sonuçlanmamış bir değişim talebi var.',
      too_late: 'Vardiyanın başlamasına çok az kaldı; değişim talebi zamanında sonuçlanamaz.',
      target_invalid: 'Seçilen meslektaş ya da vardiyası bu değişime uygun değil. Listeyi yenileyip yeniden seçin.',
      assignment_not_swappable: 'Yalnız başlamamış, yayınlanmış vardiyalar değiştirilebilir.',
      blocked: 'Vardiya değişimi planlama kurallarına uymuyor (ENGEL).',
    },
    open_shift: {
      disabled: 'Açık vardiya yalnız Gelişmiş deneyimde kullanılabilir.',
      not_found: 'Açık vardiya bulunamadı.',
      not_open: 'Açık vardiya artık açık değil: atandı, iptal edildi ya da başladı.',
      claim_exists: 'Bu açık vardiyaya zaten talip oldunuz.',
      claim_not_found: 'Talip bulunamadı.',
      not_eligible: 'Bu açık vardiyaya yalnız lokasyonunda ya da departmanında çalışanlar talip olabilir.',
      blocked: 'Bu açık vardiya planlama kurallarına göre bu çalışana atanamaz (ENGEL).',
    },
    availability: {
      disabled: 'Müsaitlik ve vardiya tercihi şirketinizde kapalı.',
    },
    self: {
      employee_required: 'Bu işlem için etkin bir çalışan kaydınız olmalı. İK ile görüşün.',
    },
    overtime: {
      no_assignment: 'Bu gün uzatılacak vardiya yok ya da aralık vardiyaya değmiyor. Ek vardiya için bir şablon seçin.',
      nothing_added: 'İstenen aralık vardiyanın içinde; eklenecek süre yok.',
      too_long: 'Uzatılmış vardiya 24 saati aşamaz.',
    },
  },
  timekeeping: {
    rule_set: {
      not_found: 'Çalışma kuralı seti bulunamadı.',
      version_conflict: 'Kural seti siz düzenlerken başka biri tarafından değiştirildi. Güncel hâlini açıp tekrar deneyin.',
      legal_envelope:
        'Bazı değerler yasal sınırların dışında: yasal üst sınırlar yalnız düşürülebilir, alt sınırlar yalnız artırılabilir.',
      not_supported: 'Kural setinde henüz desteklenmeyen bir değer var.',
    },
    rule_set_binding: {
      overlap: 'Aynı tarihlerde başka bir kural seti bağlaması yazıldı. Güncel hâlini açıp tekrar deneyin.',
    },
    employee: {
      not_found: 'Çalışan bulunamadı ya da yetki kapsamınızda değil.',
      required: 'Hesabınıza bağlı etkin bir çalışan kaydı yok. İK ile görüşün.',
    },
    day: {
      no_open_session: 'Bu günde açık mesai yok; kapatılacak mesai bulunamadı.',
      no_planned_end: 'Bu gün için planlı vardiya yok. Bitiş saatini "Eksik bitiş ekle" ile yazın.',
      planned_end_not_reached: 'Vardiyanın planlı bitişi henüz gelmedi.',
      session_ambiguous: 'Bu günde birden çok açık mesai var. Bitişi "Eksik bitiş ekle" ile yazın.',
    },
    overtime_candidate: {
      not_found: 'Fazla süre adayı bulunamadı. Kalem kalkmış ya da yetki kapsamınızda olmayabilir.',
      not_pending: 'Bu fazla süre adayına zaten karar verilmiş. Listeyi yenileyin.',
    },
    location: {
      not_found: 'Lokasyon bulunamadı.',
    },
    department: {
      not_found: 'Departman bulunamadı.',
    },
    consent: {
      not_found: 'Çalışan onayı bulunamadı.',
      already_revoked: 'Bu onay zaten geri alınmış.',
      document_not_found: 'Bu onayın açılabilecek bir belgesi yok. Belge yüklenmemiş ya da saklama süresi dolmuş olabilir.',
    },
    recompute_job: {
      not_found: 'Yeniden hesap işi bulunamadı.',
    },
    legal_set: {
      not_found: 'Yasal parametre sürümü bulunamadı.',
      not_draft: 'Yayınlanmış sürüm değiştirilemez. Yeni bir taslak açın.',
      draft_exists: 'Açık bir taslak zaten var. Önce onu düzenleyin ya da yayınlayın.',
      no_published: 'Yayınlanmış bir yasal parametre sürümü yok.',
      fixed_immutable: 'Sabit yasal değerler değiştirilemez; yalnız yoruma dayanan değer teyit notuyla düzeltilebilir.',
      scenario_deviation: 'Yasal kabul senaryolarından biri beklenenden sapıyor. Yayınlamak için sapmayı yazılı olarak onaylayın.',
    },
    // S36: dönem yaşam döngüsü (timekeeping.md "Dönem yaşam döngüsü (S36)").
    period: {
      not_found: 'Puantaj dönemi bulunamadı. Silinmiş ya da kapsamınızın dışında olabilir.',
      invalid_transition: 'Dönemin şu anki durumunda bu işlem yapılamaz. Sayfayı yenileyip dönemin durumunu kontrol edin.',
      approval_required: 'Şirketinizde dönem kilitlenmeden önce müdür onayı gerekiyor. Önce dönemi onaylatın.',
      not_ended: 'Dönem henüz bitmedi; dönem sona erdikten sonra kilitlenebilir.',
      has_blockers: 'Kontrol listesinde ENGEL var; dönem kilitlenmedi. Kalemleri çözüp tekrar deneyin.',
      later_period_locked: 'Sonraki dönem kilitli. Yalnız en son kilitli dönemin kilidi açılabilir; önce sonraki dönemin kilidini açın.',
      overlap: 'Bu tarihlerle çakışan bir dönem zaten var.',
      scope_change_blocked:
        'Dönem kapsamı şu an değiştirilemez: incelemede ya da onaylanmış bir dönem veya açık döneme yazılmış fark kaydı var. Önce o dönemi kilitleyin ya da incelemeyi geri alın.',
      day_locked: 'Bu gün kilitli bir dönemde; düzenlenemez. Onaylanan düzeltme sonraki döneme fark kaydı olarak yazılır.',
      locked_only: 'Yalnız kilitli dönemlerin puantajını görebilirsiniz.',
      // S37-b: serbest zaman tahakkuku yazılamayınca kilit geri alınır.
      time_in_lieu_failed: 'Serbest zaman defterine yazılamadı; dönem kilitlenmedi. Tekrar deneyin.',
    },
    // S37-b: telafi çalışması borç defteri (timekeeping.md "Denkleştirme, serbest zaman ve telafi (S37-b)").
    make_up_debt: {
      not_found: 'Telafi borcu bulunamadı. İptal edilmiş ya da yetki kapsamınızın dışında olabilir.',
      not_open: 'Bu telafi borcu açık değil (iptal edilmiş).',
    },
    // S37-a: bordro aktarım profilleri ve aktarım (timekeeping.md "Bordro aktarım profilleri ve aktarım (S37-a)").
    payroll_profile: {
      not_found: 'Bordro aktarım profili bulunamadı. Arşivlenmiş ya da kaldırılmış olabilir.',
      system_readonly: 'Genel profil ürünün kendi biçimidir; değiştirilemez. Hazır profilden kopyalayıp kendi profilinizi düzenleyin.',
    },
    export: {
      not_found: 'Bordro aktarımı bulunamadı. Başka bir şirkete ait ya da yetki kapsamınızın dışında olabilir.',
      period_not_locked: 'Bordro aktarımı yalnız kilitli dönemden yapılır. Önce dönemi kilitleyin.',
      identity_missing: 'Bazı çalışanların kimlik bilgisi eksik; aktarım yapılmadı. Kişi kartlarını tamamlayıp tekrar deneyin.',
      not_ready: 'Aktarım dosyası henüz hazır değil ya da üretilemedi.',
      superseded: 'Dönemin kilidi açıldığı için bu aktarım geçersiz. Dönem yeniden kilitlenince yeni aktarım yapın.',
      checksum_mismatch: 'Dosyanın saklama süresi dolduğu için yeniden üretildi, ancak içerik ilk aktarımla aynı çıkmadı. Yeni bir aktarım yapın.',
      no_period: 'Önizleme için dönem yok. İlk puantaj dönemi açılınca önizleme yapılabilir.',
    },
    // S34: FM ön onayı talebi (timekeeping.md "FM ön onayı (S34)").
    overtime_request: {
      blocked: 'Fazla çalışma talebi planlama kurallarına uymuyor (ENGEL); hiçbir talep kaydedilmedi.',
      not_found: 'Fazla çalışma talebi bulunamadı.',
      not_pending: 'Talep sonuçlandı; yalnız bekleyen talep iptal edilebilir.',
      override_forbidden: 'Yasal dayanakla (md. 42/43) istemek için bu çalışanın çizelgesini yayınlama yetkiniz olmalı.',
    },
  },
  workforce: {
    activation: {
      not_found: 'Davet bulunamadı.',
      phone_required: 'SMS ya da yerinde QR ile davet için çalışanın cep telefonu kayıtlı olmalı.',
      email_required: 'E-postayla davet için çalışanın e-posta adresi kayıtlı olmalı.',
      contact_required: 'Davet için çalışanın cep telefonu ya da e-posta adresi kayıtlı olmalı.',
      link_not_allowed: 'Bağlantıyı kopyalama ve yerinde QR yalnız Çalışan rolündeki davetlerde kullanılabilir.',
      no_account_mode: 'Kioskla çalışan ya da hesabı olmayan çalışana davet gönderilmez.',
      already_active: 'Çalışanın hesabı zaten açık.',
      employee_terminated: 'İşten çıkışı yapılmış kişiye davet gönderilemez.',
      role_invalid: 'Bu rol davetle verilemez.',
      not_pending: 'Davet tamamlanmış, iptal edilmiş ya da süresi dolmuş.',
      invalid: 'Bağlantı geçersiz. Yöneticinizden yeni bağlantı isteyin.',
      expired: 'Bağlantının süresi dolmuş. Yöneticinizden yeni bağlantı isteyin.',
      revoked: 'Bu bağlantı artık geçerli değil. Yöneticinizden yeni bağlantı isteyin.',
      completed: 'Hesabınız zaten açık. Oturum açabilirsiniz.',
      code_not_requested: 'Önce doğrulama kodu isteyin.',
      verification_invalid: 'Doğrulamanın süresi doldu. Yeni kod isteyip telefonunuzu ya da e-postanızı yeniden doğrulayın.',
      scope_invalid: 'Seçilen kapsam bulunamadı. Departmanı ya da şubeyi yeniden seçin.',
      notice_invalid: 'Aydınlatma metni bulunamadı. Sayfayı yenileyip metni yeniden okuyun.',
      // S62-c (SK-19) ve SK-29: SMS kapalı ya da şirket SMS'li planda değil; SMS daveti ve e-postası olmayan kişinin (kodu telefona gideceği
      // için) daveti gönderilmez.
      sms_unavailable:
        "Davet ve doğrulama kodu SMS'le gönderilemiyor. Çalışanın e-posta adresini ekleyip e-postayla davet edin ya da kioskta sicil ve PIN'le mesai kaydı için oturum biçimini Kiosk yapın.",
      in_person_single: 'Kişiye özel aktivasyon QR\'ı tek kişi içindir. Birden çok kişi için toplu yerinde aktivasyon oturumu açın.',
      quota_exceeded: 'Mesaj kotası bu gönderim için yetmiyor. Hiçbir davet gönderilmedi.',
    },
    // S31: toplu yerinde aktivasyon oturumu (05 §8.5).
    activation_session: {
      not_found: 'Aktivasyon oturumu bulunamadı.',
      no_targets: 'Aktivasyon bekleyen, telefonu kayıtlı çalışan yok. Önce çalışanlara davet gönderin ya da telefonlarını kaydedin.',
      too_many: 'Bir aktivasyon oturumunda en çok 500 kişi olabilir.',
      invalid: 'Aktivasyon QR\'ı geçersiz. İK\'dan yeni QR isteyin.',
      expired: 'Aktivasyon oturumu sona erdi. İK\'dan yeni QR isteyin.',
      no_match: 'Bu numara aktivasyon bekleyen bir çalışanla eşleşmedi. Numaranızı kontrol edin ya da İK\'ya başvurun.',
      // S62-c (SK-19) ve SK-29: SMS gönderilemiyorsa kod e-postaya gider; e-postası olmayan kişi bu yolla hesap açamaz.
      sms_unavailable:
        "Doğrulama kodu SMS'le gönderilemiyor ve kayıtlı e-posta adresiniz yok. İK'dan e-posta adresinizi eklemesini isteyin.",
    },
    // S31: hesapsız çalışana aydınlatma metninin kâğıtla tebliği (05 §8.9).
    notice: {
      not_published: 'Şirketin yayınlanmış aydınlatma metni yok; önce Ayarlar › Aydınlatma metni\'nden yayınlayın.',
      account_holder: 'Hesabı açık çalışan aydınlatma metnini uygulamada okur; kâğıt tebliğ yalnız hesabı olmayan çalışan içindir.',
      file_invalid: 'İmzalı tebliğ formunu yükleyin (PDF, JPEG ya da PNG).',
      delivered_in_future: 'Tebliğ tarihi ileri bir tarih olamaz.',
    },
    // S31: içe aktarma (05 §7.2); satır hataları sunucunun iletisiyle satırda yazılır.
    import: {
      not_found: 'İçe aktarma bulunamadı. Süresi dolmuş olabilir.',
      type_unknown: 'İçe aktarma türünü seçin.',
      file_invalid: 'İçe aktarma dosyasını (CSV ya da Excel) yükleyin.',
      file_unreadable: 'Dosya okunamadı. CSV ya da Excel (.xlsx) dosyası yükleyin.',
      empty: 'Dosyada başlık satırı ya da veri yok.',
      too_many_rows: 'Dosyada bir içe aktarmada izin verilenden çok satır var (Ayarlar › Personel). Dosyayı bölün.',
      mapping_invalid: 'Eşleme geçersiz: bilinmeyen alan, olmayan kolon ya da aynı kolona iki alan.',
      not_editable: 'İçe aktarma uygulandı ya da süresi doldu; eşleme değiştirilemez.',
      not_validated: 'Önce kolon eşlemesini tamamlayın; doğrulanmamış içe aktarma uygulanamaz.',
      expired: 'İçe aktarmanın süresi doldu; dosya silindi. Dosyayı yeniden yükleyin.',
      file_gone: 'Dosya artık saklanmıyor; eşlemeyi değiştirmek için dosyayı yeniden yükleyin.',
    },
    // S31: personel dışa aktarması (05 §7.3).
    export: {
      column_denied: 'Seçtiğiniz kolonlardan bazılarını görme yetkiniz yok.',
      column_unknown: 'Bilinmeyen bir kolon seçildi. Sayfayı yenileyin.',
      not_found: 'Dışa aktarma bulunamadı ya da süresi doldu.',
      reason_required: 'Hassas kolonlar için gerekçe yazın.',
    },
    employee: {
      not_found: 'Çalışan bulunamadı. Silinmiş olabilir.',
      no_account: 'Çalışanın bu şirkette açık bir hesabı yok; sıfırlanacak PIN yok.',
      own_pin_reset: 'Kendi PIN\'inizi Profil\'deki Güvenlik bölümünden değiştirin.',
      terminated: 'Çalışanın işten çıkışı yapılmış; kiosk kartı ya da PIN\'i verilemez.',
    },
    // Kişi kartı (S29; workforce.md "Kurallar"): tekillik, doğrulama ve alan yetkisi.
    person: {
      number_taken: 'Bu sicil numarası kullanımda.',
      national_id_taken: 'Bu TCKN başka bir kişi kaydında kayıtlı.',
      phone_taken: 'Bu cep telefonu başka bir kişi kaydında kayıtlı.',
      email_taken: 'Bu iş e-postası başka bir kişi kaydında kayıtlı.',
      national_id_invalid: 'TCKN geçersiz: 11 hane ve denetim haneleri doğru olmalı.',
      national_id_required: 'Şirket ayarı gereği TCKN zorunlu.',
      iban_invalid: 'IBAN geçersiz.',
      birth_date_invalid: 'Doğum tarihi ileri bir tarih olamaz.',
      birth_date_missing: 'Doğum tarihi girilmemiş: yıllık izinde yaş tabanı ve genç işçi kuralları uygulanamaz.',
      under_minimum_age: 'Çalışan işe giriş tarihinde asgari çalışma yaşını doldurmamış; işe alım yapılamaz (4857 md. 71).',
      contract_end_required: 'Belirli süreli sözleşmede bitiş tarihi zorunlu.',
      full_mode_field: 'Bu alan yalnız tam kayıt modunda gönderilir.',
      department_invalid: 'Departman bulunamadı ya da arşivde.',
      branch_invalid: 'Şube bulunamadı ya da arşivde.',
      branch_mismatch: 'Departman başka bir şubeye bağlı; şube ile departman uyuşmuyor.',
      position_invalid: 'Pozisyon bulunamadı ya da arşivde.',
      cost_center_invalid: 'Maliyet merkezi bulunamadı ya da arşivde.',
      legal_entity_invalid: 'Tüzel kişilik bulunamadı ya da arşivde.',
      location_invalid: 'Lokasyon bulunamadı ya da arşivde.',
      manager_invalid: 'Bağlı olduğu yönetici bu şirkette kayıtlı bir kişi olmalı ve kişinin kendisi olamaz.',
      sensitive_write_denied: 'TCKN ve IBAN\'ı yalnız hassas bilgileri görme yetkisi olan kişi girebilir.',
      health_write_denied: 'Özel nitelikli bilgiyi yalnız bu bilgileri görme yetkisi olan kişi girebilir.',
      disability_not_collected: 'Engellilik bilgisi bu şirkette toplanmıyor (Ayarlar › Personel).',
      field_not_set: 'Bu alan kişi kartında kayıtlı değil.',
      // S30: yaşam döngüsü ve öz-servis.
      branch_legal_entity_mismatch: 'Şube seçilen şirkete bağlı değil; şirketin bir şubesini seçin.',
      not_draft: 'Kayıt işlem görmüş; silinemez. İşten çıkışını yapın ya da erişimi kapatın.',
      photo_invalid: 'Fotoğraf bulunamadı; fotoğrafı yeniden yükleyin.',
      photo_not_set: 'Kişinin fotoğrafı yok.',
      verified_contact_clear: 'Doğrulanmış telefon ya da e-posta silinemez; yenisini yazın, kişi yeni adresi doğrulasın.',
    },
    employment: {
      not_found: 'Kişinin istihdam dönemi yok.',
      dates_invalid: 'İşten ayrılış tarihi işe giriş tarihinden önce olamaz.',
      reason_required: 'Kıdem başlangıcı değişikliği gerekçe ister.',
      rows_outside: 'İstihdam dönemi dışında kalan atama ya da sözleşme profili var. Önce onları düzenleyin.',
      overlaps: 'Kişinin başka bir istihdam dönemiyle çakışıyor; kişi başına tek aktif istihdam olabilir.',
      termination_via_wizard: 'İşten çıkış bilgileri buradan değiştirilmez. "İşten çıkışını yap" ya da "Çıkışı geri al"ı kullanın.',
    },
    assignment: {
      branch_required: 'Atamada şube boş olamaz.',
      outside_employment: 'Değişikliğin başlangıç tarihi kişinin bir istihdam dönemi içinde olmalı.',
      overlaps: 'Bu tarihten başlayan başka bir atamayla çakışıyor.',
      reason_required: 'Geriye dönük değişiklik gerekçe ister.',
    },
    contract_profile: {
      overlaps: 'Bu tarihlerde başka bir sözleşme profili var. Başlangıç tarihini değiştirin.',
      outside_employment: 'Sözleşme profili kişinin bir istihdam dönemi içinde olmalı.',
    },
    department: {
      not_found: 'Departman bulunamadı. Silinmiş ya da arşivlenmiş olabilir.',
      manager_invalid: 'Müdür bu şirkette kayıtlı bir kişi olmalı.',
      in_use:
        'Departmanda güncel ya da ileri tarihli ataması olan kişiler var. Arşivlemeden önce onları başka bir departmana taşıyın.',
      has_children: 'Alt departmanı olan departman arşivlenemez. Önce alt departmanları taşıyın.',
      cycle: 'Departman kendisinin ya da alt departmanlarından birinin altına taşınamaz.',
      parent_invalid: 'Üst departman bulunamadı ya da arşivde.',
      code_taken: 'Bu departman kodu kullanımda.',
    },
    branch: {
      not_found: 'Şube bulunamadı. Arşivlenmiş olabilir.',
      code_taken: 'Bu şube kodu kullanımda.',
      default: 'Varsayılan şube arşivlenemez.',
      in_use: 'Şubede güncel ya da ileri tarihli ataması olan kişiler ya da lokasyonlar var.',
      timezone_invalid: 'Geçerli bir saat dilimi seçin.',
    },
    legal_entity: {
      not_found: 'Tüzel kişilik bulunamadı. Arşivlenmiş olabilir.',
      default: 'Varsayılan tüzel kişilik arşivlenemez.',
      in_use: 'Tüzel kişiliğin şubesi ya da istihdam dönemi var.',
    },
    position: {
      not_found: 'Pozisyon bulunamadı. Arşivlenmiş olabilir.',
      in_use: 'Pozisyonda güncel ya da ileri tarihli ataması olan kişiler var.',
    },
    cost_center: {
      not_found: 'Maliyet merkezi bulunamadı. Arşivlenmiş olabilir.',
      code_taken: 'Bu maliyet merkezi kodu kullanımda.',
      in_use: 'Maliyet merkezi güncel bir atamada ya da departmanda kullanılıyor.',
    },
    protection_period: {
      not_found: 'Koruma dönemi bulunamadı.',
    },
    // S30 (workforce.md "Kurallar"): işten çıkış, geri alma, yeniden işe alım, iletişim ve profil değişikliği.
    termination: {
      last_day_before_hire: 'Son çalışma günü işe giriş tarihinden önce olamaz.',
      not_employed: 'Kişinin süren bir istihdam dönemi yok; işten çıkışı zaten yapılmış olabilir.',
      not_terminated: 'Kişinin geri alınacak bir işten çıkışı yok.',
      reason_code_invalid: 'Listeden bir SGK işten ayrılış kodu seçin.',
      self: 'Kendi işten çıkışınızı yapamazsınız.',
    },
    rehire: {
      hire_before_termination: 'Yeni işe giriş tarihi önceki dönemin son çalışma gününden sonra olmalı.',
      still_employed: 'Kişinin istihdamı sürüyor; yeniden işe alım yalnız işten çıkışı yapılmış kişide yapılır.',
    },
    contact_change: {
      field_not_allowed: 'İş e-postasını İK değiştirir; siz kişisel e-postanızı ve cep telefonunuzu değiştirebilirsiniz.',
      not_found: 'Bekleyen iletişim değişikliği bulunamadı ya da süresi doldu.',
      unchanged: 'Yeni adres kayıtlı adresle aynı.',
    },
    profile_change: {
      empty: 'Değiştirmek istediğiniz ad, soyad ya da IBAN\'ı yazın.',
      pending: 'Onay bekleyen bir değişiklik talebiniz var. Sonuçlanınca ya da geri çekince yenisini açabilirsiniz.',
      photo_missing: 'Talepteki fotoğraf artık yok; uygulanamadı.',
      not_employed: 'Kişinin istihdamı sona ermiş; değişiklik uygulanamadı.',
    },
    location: {
      not_found: 'Lokasyon bulunamadı. Arşivlenmiş olabilir.',
      code_taken: 'Bu lokasyon kodu kullanımda. Arşivdeki lokasyonların kodları da dolu sayılır.',
      in_use:
        'Bu lokasyon bazı çalışanların güncel ya da ileri tarihli atamasında birincil lokasyon. Önce çalışanları başka bir lokasyona taşıyın.',
    },
    // Adres arama (Nominatim): saniyede bir istek sırası doldu ya da servis yanıt vermedi; konum haritada iğneyle de işaretlenir.
    geocode: {
      busy: 'Adres arama şu an yoğun. Birkaç saniye sonra yeniden deneyin ya da konumu haritada iğneyle işaretleyin.',
      unavailable: 'Adres arama şu an yanıt vermiyor. Biraz sonra yeniden deneyin ya da konumu haritada iğneyle işaretleyin.',
    },
  },
  // S33 (İzin 2.0): sunucunun kimlik taşıyan bulunamadı iletileri yerine; öteki TimeOff kodlarının Türkçe iletisi sunucudan
  // gelir (kural bulguları `blocks` uzantısıyla ayrıca listelenir).
  timeoff: {
    type: { not_found: 'İzin türü bulunamadı.' },
    policy: { not_found: 'İzin politikası bulunamadı.' },
    request: { not_found: 'İzin talebi bulunamadı. Geri çekilmiş ya da yetki kapsamınızın dışında olabilir.' },
    document: { not_found: 'Belge bulunamadı ya da açma yetkiniz yok.' },
    adjustment_proposal: { not_found: 'Fark önerisi bulunamadı.' },
    collective: { not_found: 'Toplu izin bulunamadı.' },
    nursing: { not_found: 'Süt izni hakkı bulunamadı.' },
  },
  // S41: kendi kendine kayıt (07 §14.3; ekranlar S42'de). Bekleme süresi saniyeyle yazılmaz: kayıt sınırı saatlerce sürebilir.
  signup: {
    not_found: 'Kayıt başvurusu bulunamadı ya da süresi doldu. Kayda yeniden başlayın.',
    disposable_email: 'Geçici e-posta adresiyle kayıt yapılamaz. İşletmenizin e-posta adresini yazın.',
    too_many: 'Çok sayıda kayıt denemesi yapıldı. Biraz sonra tekrar deneyin.',
    captcha_required: 'Devam etmek için güvenlik doğrulamasını tamamlayın.',
    captcha_failed: 'Güvenlik doğrulaması geçmedi. Yeniden deneyin.',
    token_invalid: 'Kayıt doğrulamanızın süresi doldu. Kodu yeniden doğrulayın.',
    business_missing: 'Önce işletme bilgilerini girin.',
    acceptance_missing: 'Devam etmek için abonelik sözleşmesini ve kullanım koşullarını kabul edin.',
    completed: 'Bu kayıt tamamlandı. Oturum açarak devam edin.',
    not_completed: 'Kaydınız henüz tamamlanmadı. Kalan adımları bitirip tekrar deneyin.',
  },
  // S43: abonelik ve fatura uçları (`/api/v1/billing/*`, yalnız İşletme sahibi) ve sahte ödeme sayfası. Plan seçilemezlik nedenleri
  // (`offers[].unavailableReason`) de bu kodlardır.
  billing: {
    provider_disabled: 'Ödeme adımı henüz açık değil. Ücretli plana geçiş için bize yazın.',
    not_ready: 'Bu işlem henüz açık değil. Biraz sonra yeniden deneyin.',
    account: { required: 'Plan seçmeden önce fatura bilgilerinizi girin.' },
    plan: {
      quote_only: 'Bu plan için teklif alın; ürün içinden satın alınamaz.',
      free_limits_exceeded:
        'Ücretsiz plana geçmek için aktif çalışan ve lokasyon sayınız Ücretsiz planın sınırları içinde olmalı.',
      no_yearly_price: 'Bu plan bu peşin ödeme süresiyle alınamaz. Aylık ödemeyi ya da başka bir peşin süreyi seçin.',
      unchanged: 'Şirketiniz zaten bu planda ve bu ödeme döneminde. Başka bir plan ya da ödeme dönemi seçin.',
    },
    contract: {
      active: 'Peşin sözleşmeniz sürerken plan ya da ödeme dönemi ürün içinden değiştirilemez. Destek ekibiyle görüşün.',
    },
    cancel: {
      not_allowed: 'Bu abonelik ürün içinden iptal edilemez. Deneme süresi kendiliğinden biter; Kurumsal sözleşme için destek ekibiyle görüşün.',
    },
    checkout: {
      not_found: 'Ödeme sayfası bulunamadı. Abonelik sayfasından yeniden başlatın.',
      expired: 'Ödeme sayfasının süresi doldu. Abonelik sayfasından yeniden başlatın.',
      used: 'Bu ödeme sayfası zaten sonuçlandı. Sonucu abonelik sayfasında görebilirsiniz.',
    },
    invoice: {
      not_found: 'Fatura bulunamadı. Faturalar listesinden yeniden açın.',
      // S43 bölüm 5: "Şimdi öde" yalnız ödenmemiş faturada.
      not_payable: 'Bu fatura ödeme beklemiyor. Faturalar listesini yenileyin.',
    },
    payment_method: {
      missing: 'Kayıtlı ödeme yönteminiz yok. Ödeme ve fatura bilgileri sekmesinden kart ekleyin.',
      required: 'Kayıtlı ödeme yönteminiz yok. Ödeme ve fatura bilgileri sekmesinden kart ekleyin; eklenen kartla ödenmemiş faturalar hemen denenir.',
    },
    // S43 bölüm 5: tahsilat takibinin backoffice süre uzatması (bölüm 6 ekranı bu kodları gösterir).
    dunning: {
      not_found: 'Şirketin açık tahsilat takibi yok.',
      grace_not_allowed: 'Askıya alınmış şirkette süre uzatılamaz; askıyı kaldırın.',
    },
  },
  // S44 (YH-S61): kapanan şirketin iade paketi (`/api/v1/tenant-exit`, yalnız İşletme sahibi) ve backoffice silme kuyruğu.
  tenancy: {
    tenant_exit: {
      not_found: 'Şirket kapatılmamış; iade paketi yok.',
    },
    return_package: {
      not_ready: 'İade paketi hazırlanıyor. Biraz sonra yeniden deneyin.',
      failed: 'İade paketi hazırlanamadı. Bize yazın; paketi yeniden hazırlayalım.',
      expired: 'İade paketinin indirme süresi doldu. Şirketinizin verisi silindi ya da silinmek üzere.',
    },
  },
  // S50: şirket duyuruları. Sunucunun iletisi kayıt ya da dosya kimliği taşıyabilir; ekrana kimlik yazılmaz. Kitle, zaman ve kural kodlarının
  // (`audience.*`, `schedule.invalid_time`, `invalid_transition`) kimliksiz iletisi sunucudan gelir.
  announcements: {
    announcement: {
      not_found: 'Duyuru bulunamadı. Kaldırılmış ya da size açık olmayabilir.',
      withdrawn: 'Bu duyuru geri çekildi.',
      expired: 'Bu duyurunun süresi doldu; artık onay ve hatırlatma alınmıyor.',
    },
    ack: {
      version_mismatch: 'Duyuru güncellendi; güncel hâlini okuyup yeniden onaylayın.',
      not_required: 'Bu duyuru okuma onayı istemiyor.',
    },
    attachment: {
      file_invalid: 'Ek kullanılamıyor: duyuru eki olarak sizin yüklediğiniz bir dosya olmalı. Eki kaldırıp yeniden yükleyin.',
      // `file_invalid`'in `reason: "in_use"` uzantısı (sunucu kodu değil; düzenleyici uzantıya göre seçer).
      in_use: 'Bu dosya başka bir duyuruda kullanılıyor; yeniden yükleyin.',
      not_found: 'Ek bulunamadı; duyurudan kaldırılmış olabilir.',
    },
  },
} as const;
